import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgPill = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M13.8374 3.975L4.11494 13.6983C3.31199 14.5223 2.86594 15.6295 2.87338 16.7799C2.88082 17.9304 3.34116 19.0317 4.1547 19.8452C4.96824 20.6588 6.0695 21.1191 7.21999 21.1266C8.37049 21.134 9.47761 20.688 10.3016 19.885L20.0249 10.1667C20.846 9.34615 21.3075 8.23308 21.3079 7.07231C21.3083 5.91154 20.8475 4.79815 20.027 3.97708C19.2065 3.15602 18.0934 2.69453 16.9327 2.69414C15.7719 2.69375 14.6585 3.15449 13.8374 3.975V3.975Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.7217 15.4658L8.53418 9.27834"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.1665 6.185C15.3406 6.01078 15.5472 5.87258 15.7747 5.77829C16.0022 5.684 16.2461 5.63547 16.4923 5.63547C16.7386 5.63547 16.9824 5.684 17.2099 5.77829C17.4374 5.87258 17.6441 6.01078 17.8182 6.185V6.185"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgPill.displayName = 'SvgPill';
export default SvgPill;
